import React from "react";

const StyledH6Heading = ({ children, fontColor }) => {
  return (
    <p className={`text-h6 font-inter font-bold ${fontColor}`}>{children}</p>
  );
};

export default StyledH6Heading;
